import { Component, OnInit, HostListener, Output, EventEmitter } from '@angular/core';
import { ClassesUtil } from '../../utils/classes-util';
import { WindowRef } from '../../utils/window';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MainNavLinksComponent } from '../main-nav-links/main-nav-links.component';

@Component({
    selector: 'div.mbfs-mainnav',
    imports: [SharedTranslateModule, MainNavLinksComponent],
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    providers: [ClassesUtil, WindowRef]
})
export class MainNavComponent implements OnInit {

  @Output() onOverlayClick = new EventEmitter<boolean>();
  isSticky = false;

  constructor(private classesUtil: ClassesUtil) { }

  ngOnInit(): void {
  }

  onClickOverly(e?: Event): void {
    // required for closing header outside of header area
    this.onOverlayClick.emit(true);
    let mainNavs = document.getElementsByClassName('mbfs-main-nav');

    // Remove 'active' class to hide side nav
    if (mainNavs.length) {
      this.classesUtil.removeClass(mainNavs[0], 'active');
      this.classesUtil.addClass(mainNavs[0], 'hidden');
    }
  }
}
